import { useEffect } from 'react'
import { useAppSelector } from '@/store/hooks'
import { useGoogleDriveAuth } from '../hooks/useGoogleDriveAuth'

export function GoogleDriveInitializer() {
  const authenticated = useAppSelector((state) => state.auth.isAuthenticated)
  const { initialize, reset } = useGoogleDriveAuth()

  useEffect(() => {
    if (authenticated) void initialize()
    else reset()
  }, [authenticated, initialize, reset])

  return null
}
